module.exports = __webpack_public_path__ + "static/media/oculos.43bdd194.jpeg";